import React, { PureComponent } from 'react';
import { injectIntl, defineMessages } from 'react-intl';

import {
  ReactTableFilterDropdown,
  ReactTableHeaderText,
  Button as Btn,
  ExamTemplateFilter,
  ExamAttachFilter,
  AdminUserFilter,
  AdminLicenseFilter,
  AdminLogFilter,
  ExamLeakFileFilter,
  EduQuizFilter,
  PhishingTemplateFilter
} from 'components';
import { Input, Image, Dropdown, Popup, Grid } from 'semantic-ui-react';
import { Fab, IconButton, Tooltip, Button } from 'material-ui';

import classNames from 'classnames/bind';
import styles from './ReactTableSearch.css';
const cx = classNames.bind(styles);

class ReactTableSearch extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      popupOpen: false
    }
  }

  // 검색어 입력
  handleChangeSearch = e => {
    const { takeSearchValue } = this.props.searchObj;
    takeSearchValue(e.target.value);
  };

  // 필터 팝업 열기/닫기
  handlePopup = value => {
    this.setState({
      popupOpen: value
    });
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    // 검색 영역
    const {
      filterData,
      searchOptions,
      searchType,
      searchText,
      handleSearchOptions,
      handleOnSearch,
      handleInitFilter,
      paramData,
      searchTextRef,
      tempFilter
    } = this.props.searchObj;
    // 페이지 사이즈
    const {
      currentPage,
      pageSize,
      totalCount,
      defaultPageSize,
      pageSizeOptions,
      handlePageSizeOnChange
    } = this.props.searchObj;

    //필터 영역
    const {
      cancleCheck,
      filterClose,
      executeFilter,
      filters,
      checkFilter,
      cancelFilter,
      resetFilter
    } = this.props;

    const { handlePopup } = this;
    const { popupOpen } = this.state;

    const startCount = pageSize * currentPage + 1;
    let endCount = pageSize * (currentPage + 1);
    if (endCount > totalCount) {
      endCount = totalCount;
    }

    // 현재 위치
    const fullPath = window.location.pathname;
    const path = window.location.pathname.split('/').splice(1, 4);
    const auth = path[0];
    const category = path[1];
    const underCategory = path[2];

    let searchFilter = null;
    if (auth === 'mudmanage') {
      if (category === 'examtemplate') {
        if (underCategory === 'examtemplateMail') {
          searchFilter = (
            <ExamTemplateFilter
              filters={filters}
              filterClose={filterClose}
              handleInitFilter={handleInitFilter}
              cancleCheck={cancleCheck}
              executeFilter={executeFilter}
              paramData={paramData}
              tempFilter={tempFilter}
              popupOpen={popupOpen}
              handlePopup={handlePopup}
            />
          );
        } else if (underCategory === 'examtemplateAttach') {
          searchFilter = (
            <ExamAttachFilter
              filters={filters}
              filterClose={filterClose}
              handleInitFilter={handleInitFilter}
              cancleCheck={cancleCheck}
              executeFilter={executeFilter}
              paramData={paramData}
              tempFilter={tempFilter}
              popupOpen={popupOpen}
              handlePopup={handlePopup}
            />
          );
        } else if (underCategory === 'examtemplatePhishing') {
          searchFilter = (
            <PhishingTemplateFilter
              filters={filters}
              filterClose={filterClose}
              handleInitFilter={handleInitFilter}
              cancleCheck={cancleCheck}
              executeFilter={executeFilter}
              paramData={paramData}
              tempFilter={tempFilter}
              popupOpen={popupOpen}
              handlePopup={handlePopup}
            />
          );
        }
      } else if (category === 'user') {
        searchFilter = (
          <AdminUserFilter
            filters={filters}
            filterClose={filterClose}
            handleInitFilter={handleInitFilter}
            cancleCheck={cancleCheck}
            executeFilter={executeFilter}
            paramData={paramData}
            tempFilter={tempFilter}
            popupOpen={popupOpen}
            handlePopup={handlePopup}
          />
        );
      } else if (category === 'license') {
        searchFilter = (
          <AdminLicenseFilter
            filters={filters}
            filterClose={filterClose}
            handleInitFilter={handleInitFilter}
            cancleCheck={cancleCheck}
            executeFilter={executeFilter}
            paramData={paramData}
            tempFilter={tempFilter}
            popupOpen={popupOpen}
            handlePopup={handlePopup}
          />
        );
      } else if (category === 'log') {
        searchFilter = (
          <AdminLogFilter
            filters={filters}
            filterClose={filterClose}
            handleInitFilter={handleInitFilter}
            cancleCheck={cancleCheck}
            executeFilter={executeFilter}
            paramData={paramData}
            tempFilter={tempFilter}
            popupOpen={popupOpen}
            handlePopup={handlePopup}
          />
        );
      }
    } else if (auth === 'main') {
      if (category === 'exam' && underCategory === 'leakfile') {
        searchFilter = (
          <ExamLeakFileFilter
            filters={filters}
            filterClose={filterClose}
            handleInitFilter={handleInitFilter}
            cancleCheck={cancleCheck}
            executeFilter={executeFilter}
            paramData={paramData}
            tempFilter={tempFilter}
            popupOpen={popupOpen}
            handlePopup={handlePopup}
          />
        );
      } else if (fullPath === '/main/allTemplate/examtemplate') {
        searchFilter = (
          <ExamTemplateFilter
            filters={filters}
            filterClose={filterClose}
            handleInitFilter={handleInitFilter}
            cancleCheck={cancleCheck}
            executeFilter={executeFilter}
            paramData={paramData}
            tempFilter={tempFilter}
            popupOpen={popupOpen}
            handlePopup={handlePopup}
          />
        );
      } else if (fullPath === '/main/allTemplate/examtemplate/phishing') {
        searchFilter = (
          <PhishingTemplateFilter
            filters={filters}
            filterClose={filterClose}
            handleInitFilter={handleInitFilter}
            cancleCheck={cancleCheck}
            executeFilter={executeFilter}
            paramData={paramData}
            tempFilter={tempFilter}
            popupOpen={popupOpen}
            handlePopup={handlePopup}
          />
        );
      } else if (category === 'mypage' && underCategory === 'edu') {
        // to do
        // searchFilter = (
        //   <EduQuizFilter
        //     // filters={filters}
        //     // filterClose={filterClose}
        //     // handleInitFilter={handleInitFilter}
        //     // cancleCheck={cancleCheck}
        //     // executeFilter={executeFilter}
        //     paramData={paramData}
        //     tempFilter={tempFilter}
        //     checkFilter={checkFilter}
        //     executeFilter={executeFilter}
        //     cancelFilter={cancelFilter}
        //     resetFilter={resetFilter}
        //   />
        // );
      }
    }

    // 글자 수가 많을 경우 대비하여 title 속성 사용
    var title = '';
    searchOptions.map(option => {
      if (option.value === searchType) {
        title = option.text
      }
    });

    return (
      <div className={cx('react-search')}>
        <div className={cx('seacrch-input-area')}>
          <div className={cx('search-dropdown-area')}>
            <div className={cx('dropdown-arrow-area')}>
              <Image className={cx('pageSize-dropdown-image')} src="/img/table/selectbox_number_arrow.png" />
            </div>
            <Dropdown
              floating
              scrolling
              icon={null}
              value={searchType}
              className={cx('search-dropdown')}
              onChange={handleSearchOptions}
              options={searchOptions}
              title={title}
            />
          </div>
          <Input
            className={cx('react-search-input')}
            size="mini"
            placeholder={defineMessages(formatMessage({ id: 'ExamSearch_17', defaultMessage: '검색' }))}
            onKeyPress={handleOnSearch}
            onChange={this.handleChangeSearch}
            // value={searchText}
            ref={searchTextRef}
          />
          <Button id="bt-search-input" className={cx('bt-search-input')} onClick={handleOnSearch}>
            <Image src="/img/table/btn_search.png" />
          </Button>
        </div>
        {/* 필터 영역 */}
        {searchFilter}
        {underCategory !== 'edu' && (
          <Tooltip
            title={defineMessages(formatMessage({ id: 'ExamSearch_24', defaultMessage: '필터 해제' }))}
            placement="bottom">
            <IconButton className={cx('bt-filter-init')} onClick={handleInitFilter}>
              <Image src={'/img/table/btn_filter' + (Object.keys(filterData).length ? '_active' : '') + '.png'} />
            </IconButton>
          </Tooltip>
        )}

        <div className={cx('pageSize-area')}>
          <div className={cx('pageSize-status')}>{startCount + '-' + endCount + ' / ' + totalCount}</div>
          <div className={cx('dropdown-arrow-area')}>
            <Image className={cx('pageSize-dropdown-image')} src="/img/table/selectbox_number_arrow.png" />
          </div>
          <Dropdown
            floating
            scrolling
            icon={null}
            defaultValue={defaultPageSize}
            className={cx('pageSize-dropdown text-center')}
            onChange={handlePageSizeOnChange}
            options={pageSizeOptions}
          />
        </div>
      </div>
    );
  }
}

export default injectIntl(ReactTableSearch);



// WEBPACK FOOTER //
// ./src/script/components/common/ReactTableSearch.js